//import * as funcs from './constants/Functions'
//import { usePage } from '@inertiajs/inertia-react';

export * from '@/constants/Functions'
import {WHATPSAPP} from '@/constants/Site'

export function filesize(size) {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (
    (size / Math.pow(1024, i)).toFixed(2) * 1 +
    ' ' +
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  );
}

export function valAppendFormData(form, base, val) {
	switch (typeof val) {
		case 'object':
			objAppendFormData(form, val, base);
			break;
		case 'undefined':
			form.append(base, '');
			break;
		case 'boolean':
			form.append(base, val ? 1 : 0);
			break;
		case 'function':
			break;
		default:
			form.append(base, val);
			break;
	}
}

export function objAppendFormData (form, obj, base) {
	if (!obj && base) {
		form.append(base, '');
	} else if (obj instanceof File) {
		form.append(base, obj);
	} else if (obj) {
		for (const key of Object.keys(obj)) {
			const base2 = base ? `${base}[${key}]` : key;
			const val = obj[key];
			valAppendFormData(form, base2, val);
			/*switch (typeof val) {
				case 'object':
					objToFormData(form, base, val);
					break;
				default:
					
			}*/
		}
	}
}

// Transforms key/value pairs to FormData() object
export function toFormData(values = {}, method = 'POST') {
  const formData = new FormData();
  /*for (const field of Object.keys(values)) {
  	let val = values[field];
  	if (typeof val === 'object' && !val) val = '';
  	if ()
    formData.append(field, val);
  }*/
  objAppendFormData(formData, values);

  // NOTE: When working with Laravel PUT/PATCH requests and FormData
  // you SHOULD send POST request and fake the PUT request like this.
  // More info: http://stackoverflow.com/q/50691938
  if (method.toUpperCase() === 'PUT') {
    formData.append('_method', 'PUT');
  }

  return formData;
}

//window.toFormData = toFormData;

export function setClassName(base, className) {
	return (base||'')+(base&&className?' ':'')+(className||'')
}

export function currParams() {
	return new URLSearchParams(location.search.substr(1));
}

export function createURI({base=location.pathname, search=location.search, hash=location.hash}={}) {
	if (search && typeof search == 'object') {
		const params = currParams();
		Object.keys(search).forEach(key=>{
			if (typeof search[key] !== "undefined") {
				params.set(key, search[key]);
			} else {
				params.delete(key);
			}
		});
		search = params.toString();
		if (search) search='?'+search;
	}
	return base+search+hash;
}

export function paramsObj(params = currParams()) {
	return Object.fromEntries(params);
}

export function readURL(file, setResult) {
  if (file) {
    var reader = new FileReader();
    
    reader.onload = function(e) {
      setResult(e.target.result);
    }
    
    reader.readAsDataURL(file); // convert to base64 string
  } else {
	setResult(undefined);
  }
}

export function whatsappUrlMessage(text, number=WHATPSAPP?.number) {
	return 'https://wa.me/' + number + "?text=" + encodeURI(text);
}

export const idGen = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return Math.random().toString(36).substr(2, 9);
};




// FRON HERE

export const lastUrlReplacer = (text="", replacer="https://www.iqsac.com.pe", {withSlash}={}) =>{
	if (text) {
		text = text.replace(/(^(http(s)?:\/\/)?(www.)?iqsac\.com\.pe)?\/antigua\//g, replacer)
		if (withSlash && !text.startsWith('/')) text = '/'+text;
	}
	return text;
}
export const getLastUrl = (url) => {
	let last_url = lastUrlReplacer(url, "");
	if (last_url) last_url = "https://www.iqsac.com.pe/"+(last_url.replace(/^\//g, ""));
	return last_url;
}
